import request from '@/api/request'

/**
 * 套餐系列管理API接口
 * 仅用于新UI，不影响旧页面
 */

// 分页查询系列列表
export function getSeriesList(params) {
  return request({
    url: '/setmealSeries/list.do',
    method: 'post',
    data: params
  })
}

// 获取系列树形结构
export function getSeriesTree(status = null) {
  return request({
    url: '/setmealSeries/tree.do',
    method: 'get',
    params: { status }
  })
}

// 获取启用的系列列表（用于下拉选择）
export function getActiveSeries() {
  return request({
    url: '/setmealSeries/active.do',
    method: 'get'
  })
}

// 根据ID查询系列详情
export function getSeriesById(id) {
  return request({
    url: `/setmealSeries/findById.do`,
    method: 'get',
    params: { id }
  })
}

// 创建系列
export function createSeries(data) {
  return request({
    url: '/setmealSeries/add.do',
    method: 'post',
    data
  })
}

// 更新系列
export function updateSeries(id, data) {
  // 将ID添加到data中，因为传统模式不支持路径参数
  data.id = id
  return request({
    url: `/setmealSeries/update.do`,
    method: 'post',
    data
  })
}

// 删除系列
export function deleteSeries(id) {
  return request({
    url: `/setmealSeries/delete.do`,
    method: 'post',
    params: { id }
  })
}

export default {
  getSeriesList,
  getSeriesTree,
  getActiveSeries,
  getSeriesById,
  createSeries,
  updateSeries,
  deleteSeries
}
